/**
 * Hands the router's raw navigate to `AuthProvider` (ADR-0302), for the one
 * navigation that must happen inside `switchAccount`, before the new user
 * state renders. The provider sits inside the router in the app but not in
 * every test, so it renders this bridge only when there is a router.
 *
 * Raw on purpose: the path it navigates to is already prefixed, and the
 * account-aware wrappers read `useAuth`, which would be circular here.
 */

import { useEffect } from "react";
import { useNavigate, type NavigateFunction } from "react-router-dom";

export function NavigatorBridge({ target }: { target: { current: NavigateFunction | null } }) {
  const navigate = useNavigate();
  useEffect(() => {
    target.current = navigate;
    return () => {
      target.current = null;
    };
  }, [navigate, target]);
  return null;
}
